module.exports = "fragment UserDetails on User {\n  name\n  phone\n  document\n  email\n  companies {\n    id\n    status\n    user_status\n    user_roles (user: $id)\n    name\n    config {\n      email\n    }\n  }\n}\n\nquery User (\n  $id: String!,\n  $getDetails: Boolean = true\n) {\n  user (id: $id) {\n    id\n    companies {\n      user_news\n    }\n    ... UserDetails @include (if: $getDetails)\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/User.graphql
// module id = EDGK
// module chunks = 1624